import React, { useRef, useEffect, memo } from "react";
import {
  InboxArrowDownIcon,
  TruckIcon,
  ClipboardDocumentCheckIcon,
  InformationCircleIcon
} from "@heroicons/react/24/outline";

  const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ')
  }
const CardPedido2 = ({ 
  data, 
  pedidos,
  setPedidos,
  numEnvio,
  columnas, 
  handleVerMas,
  campoPrincipal,
  columnasIconos, 
  seleccionado, 
  iconosLabels,
  fechaActual,
  conta,
  handlePedidoCheck,
  idsSeleccionados,
  esProveedor
}) => {

  const Item = ({ 
     card,
     data,
     columnas,
     handleVerMas,
     campoPrincipal,
     index,
     columnasIconos,
     seleccionado,
     idsSeleccionados,
     iconosLabels}) => {
    const cursoRef = useRef(null);
    useEffect(() => {
      
        const observer = new IntersectionObserver((entries) => {
          //if(Object.values(cursoRef.current.classList).includes("oculto")){
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            
            try {
              if(!cursoRef.current.classList.contains("elementFadeIn")){
                cursoRef.current.classList.add("elementFadeIn");
              }
              if(cursoRef.current.classList.contains("oculto")){
                cursoRef.current.classList.remove("oculto");
              }
            } catch (error) {
              
            }
               
          } else {
            try {
              if(!cursoRef.current.classList.contains("oculto")){
                cursoRef.current.classList.add("oculto");
              }
              if(cursoRef.current.classList.contains("elementFadeIn")){
                cursoRef.current.classList.remove("elementFadeIn");
              }
            } catch (error) {
              
            }
            
          }
        });
      });
      if (cursoRef.current) {
       observer.observe(cursoRef.current);
      }
      return () => {
        observer.disconnect();
      };
    
    
    }, []);

    const formateoString = (label) => {
      const option = {
        "Pagado" :  "Facturado",
        "Recepción Parcial" : "Recepción incompleta",
        "Entrega Parcial" : "Entrega incompleta",
      }
      return option[label] || label
    }

    return (
    <div
      key={ index + 2000 }
      ref={esProveedor?null: cursoRef}
      className={`transition duration-500 ease flex flex-col justify-between overflow-hidden rounded-xl bg-primarioMira shadow  hover:bg-secundarioMira hover:shadow-white hover:border-2`}
    >
      <div className="p-4 ">
        <div className="flex justify-between">
          <div className="flex-1 flex flex-row ">
            <div className="w-full">
              <div className="text-lg  text-gray-100 font-sm flex flex-row justify-between">
                {/*esProveedor && card.Estatus === "Revisado"?
                <input 
                name="selected"
                type="checkbox"
                checked={idsSeleccionados.includes(card[campoPrincipal])}
                className="my-auto text-azulBrillanteMira mr-4 p-3 rounded-md  transition duration-500 ease"
                onChange={(e) => handlePedidoCheck(e, index, pedidos, setPedidos, numEnvio, fechaActual, card, campoPrincipal)}
                ></input>:
                null
                */}
                <div className="flex flex-row justify-between w-full mb-4">
                  <div className="flex flex-col 2xl:flex-row gap-2">
                    <p className="flex font-medium self-end">{columnas[1].active && card[`${columnas[1].fieldName}`]}</p>
                    {(card.Estatus === "Revisado" && card[`${columnasIconos[2].fieldName}`] > 0) && (
                      <p className="text-yellow-400 text-sm self-end">(Incompleto)</p>
                    )}
                  </div>
                  <div 
                    className={classNames(
                      ["Pagado", "Entregado", "Recibido"].includes(card.Estatus)?
                      " bg-blue-200 text-blue-800":
                      ["Revisado"].includes(card.Estatus)?
                      " bg-green-200 text-green-800":
                      ["Recepción Parcial", "Entrega Parcial"].includes(card.Estatus)?
                      " bg-yellow-200 text-yellow-800":
                      ["Pendiente de Recibir", "Despachado"].includes(card.Estatus)?
                      " bg-orange-200 text-orange-800":
                      ["Pendiente", "Pedido", "Pendiente de Revisar"].includes(card.Estatus) &&
                      " bg-red-200 text-orange-800", 
                      " rounded-xl p-2 text-center content-center"
                  )}><p className="text-sm font-semibold flex ">{formateoString(card.Estatus)}</p>
                  </div>
                </div>
              </div>
              {
              
                <div className="text-md text-gray-400 flex flex-col lg:flex-row justify-between gap-2">
                  <div className="flex flex-col justify-end mb-2">
                    <span 
                      className={"rounded-md /p-1 truncate text-5xl font-medium inline-flex /items-start /py-2.5 text-gray-100 "}
                      >
                      {esProveedor?`#${card[columnas[0].fieldName] || card['IdEnvio']}`:
                      <div className="flex flex-col">
                        <div className="flex flex-row gap-2 justify-between">
                          <p className="self-end text-xl">Envío</p>
                          <p className="self-end text-gray-100 text-3xl">{`#${card['IdEnvio']}`}</p>
                        </div>
                        <div className="flex flex-row gap-2 justify-between">
                          <p className="self-end text-xl">Pedido</p>
                          <p className="self-end text-gray-100 text-3xl">{`#${card['IdPedido']}`}</p>
                        </div>
                      </div>}
                      {(card.Estatus === "Revisado" && card[`${columnasIconos[2].fieldName}`] > 0) && (
                            <InformationCircleIcon className="w-8 h-8 text-yellow-400 self-end mx-2"/>
                      )}
                    </span>
                  </div>
                <div className="flex flex-col">
                  <p className="text-gray-200">{ columnas[2].active && card[`${columnas[2].fieldName}`] }</p>
                  <p>{card.Productos[0]?.NoEnvioProv && `Número de envío de proveedor ${card.Productos[0]?.NoEnvioProv}`}</p>
                <time dateTime="2024-08-14" className="text-sm">Pedido registrado en {card?.FechaIngreso}</time>
                <div className="text-gray-400 text-sm">
                  <time dateTime="2024-08-14">Último envío registrado en {card?.UltimoEnvio}</time>
                  {((conta || esProveedor) && card.Estatus === "Pagado") && (
                    <div className="flex flex-row gap-2 mt-2">
                      <p>Factura: {card?.Factura}, </p><p>facturado en {card?.FechaFactura}</p>
                    </div>
                  )}
                </div>
                </div>
                </div>
              
              }
            </div>
          </div>
        </div>
        <div className="my-4">
          <Iconos 
            item={card} // no undef
            columnasIconos={columnasIconos}
            seleccionado={seleccionado} 
            Idx={index}  // no undef
            iconosLabels={iconosLabels}
            esProveedor={esProveedor}
          />
        </div>
      </div>

      <div className="flex justify-between px-5">
      
        <div aria-hidden="true" className="w-[85%] py-1 /my-auto">
        
          <div className="overflow-hidden rounded-full bg-gray-600">
            <div
              style={{ width: `${card?.Porcentaje}%` }}
              className={classNames(
                ["Pagado", "Entregado", "Recibido"].includes(card.Estatus)?
                "bg-blue-200 text-blue-900":
                ["Revisado"].includes(card.Estatus)?
                "bg-green-300 text-green-900":
                ["Recepción Parcial", "Entrega Parcial"].includes(card.Estatus)?
                "bg-yellow-200 text-yellow-900":
                ["Pendiente de Recibir"].includes(card.Estatus)?
                "bg-orange-200 text-orange-900":
                ["Pendiente", "Pedido", "Pendiente de Revisar"].includes(card.Estatus) &&
                "bg-red-200 text-orange-900", 
                "rounded-md p-1 font-medium"
            )}
            />
          </div>
          
        </div>
        <div className="py-1">
          <dd className="text-grisMira text-base">{`${card?.Porcentaje}%`}</dd>
        </div>
      </div>
      {card?.UltimoEnvio ?
      null:
          <div className="flex justify-between px-5 py-1">
              <dt className="text-grisMira text-base"></dt>
              <dd className="text-gray-300 text-base">
              <time dateTime="2024-08-14">No se han registrado envíos de este producto</time>
              </dd>
          </div>
      }
      {/*(esProveedor && card.Estatus !== "Revisado") && (*/}
        <button 
        className="w-full p-2 rounded-b-md px-auto py-auto text-center text-md text-gray-100 hover:bg-secundario bg-azulBrillanteMira flex flex-row justify-center   transition duration-500 ease "
        onClick={(e) => handleVerMas(e, data, (card[campoPrincipal] || card['IdEnvio']))}
        >{["Revisado", "Recibido"].includes(card?.Estatus)? "Detalle": "Continuar"}{/* <ChevronRightIcon className="w-5 h-5 my-auto mx-2 font-medium"/> */}
        </button>
      {/* )} */}
      
    </div>
  
    )
  }

  return (
    <>
    
      <div 
        //key={ random()+ 4000}
        className={`grid gap-5 grid-cols-1 2xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2 /elementFadeIn /justify-between /flex /flex-row`}
      >
      {/* Card */}
      { 
        data?.map((card, index) => (
          <Item 
          card={card}
          data={data}
          index={index}
          columnas={columnas}
          handleVerMas={handleVerMas}
          campoPrincipal={campoPrincipal}
          fechaActual={fechaActual}
          columnasIconos={columnasIconos}
          seleccionado={seleccionado} 
          iconosLabels={iconosLabels}
          idsSeleccionados={idsSeleccionados}
          />
        ))
      }
        </div>
        </>
      );
};

export default CardPedido2;

const Iconos = ({ item, columnasIconos, seleccionado, Idx, iconosLabels, esProveedor }) => {
  
  return (
    <div 
    key={Idx + 6000}
    className="flex flex-row gap-2 /bg-red-200">

      <div className="flex flex-col w-1/3">
        <InboxArrowDownIcon className="w-5 h-5 text-gray-500 mx-auto" />
        <div className="/truncate text-sm text-gray-400 text-center">
          { item[columnasIconos[0].fieldName] || item["CantidadEnvio"] || 0} { iconosLabels[0].fieldName }
        </div>
      </div>

     <div className="flex flex-col w-1/3">
      <TruckIcon className="w-5 h-5 /text-gray-300   text-gray-500  mx-auto" />
      {esProveedor && (
        <div className="text-sm text-gray-400 text-center flex flex-row gap-1 ">
          <p>{item["CantidadDespachada"]}</p> <p>{"Unidades despachadas"}</p>
        </div>
      )}
      <div className="text-sm text-gray-400 text-center flex flex-row gap-1">
        <p>{(item[columnasIconos[1].fieldName] || item["CantidadRecibida"] || 0)}</p><p>{ iconosLabels[1].fieldName }</p>
      </div>
     </div>
    
     <div className="flex flex-col w-1/3">
      <ClipboardDocumentCheckIcon className={
        (item.Estatus === "Revisado" && item[`${columnasIconos[2].fieldName}`] > 0) ?
        "w-5 h-5 text-yellow-400  mx-auto" : "w-5 h-5 text-gray-500  mx-auto"} />
      <div className=" /truncate text-sm text-gray-400 text-center">
        {(item[columnasIconos[2].fieldName] ||  item[columnasIconos[3].fieldName]) || 0} { iconosLabels[2].fieldName }
      </div>
     </div>

    </div>
  )
}

const FacturaIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v7.5m2.25-6.466a9.016 9.016 0 0 0-3.461-.203c-.536.072-.974.478-1.021 1.017a4.559 4.559 0 0 0-.018.402c0 .464.336.844.775.994l2.95 1.012c.44.15.775.53.775.994 0 .136-.006.27-.018.402-.047.539-.485.945-1.021 1.017a9.077 9.077 0 0 1-3.461-.203M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>
  )
}